<h2 mat-dialog-title class="text-lg font-bold mb-1">
    Rechazar
</h2>
<mat-dialog-content class="modal-content">
    <form #updateForm="ngForm" class="grid grid-cols-1 gap-4">
      <mat-form-field class="w-full">
        <mat-label>Motivo de rechazo</mat-label>
        <mat-select
          [formControl]="reasonRejectionControl"
          name="reasonRejectionId"
          [required]="reasonRejectionRequired"
          [disabled]="reasonRejectionDisabled"
        >
          <mat-option
            *ngFor="let reasonRejection of reasonRejectionList"
            [value]="reasonRejection._id"
            class="text-content"
          >
            {{ reasonRejection.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="reasonRejectionControl.hasError('required')">
          Este campo es obligatorio.
        </mat-error>
      </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button
      mat-raised-button
      color="warn"
      (click)="openConfirmationDialog()"
      [disabled]="!updateForm.valid || reasonRejectionControl.value == null"
      class="justify-end"
    >
        Rechazar
    </button>
</mat-dialog-actions>

<ng-template #orderConfirmationDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
      <div class="flex items-center">
        <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
          style="font-size: 32px"></mat-icon>
      </div>
      <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            {{data.title}}
          </h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>{{data.message}}</p>
          </mat-dialog-content>
      </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
      <button mat-button mat-dialog-close class="align-left">
        Conservar
      </button>
      <button mat-raised-button color="warn" [mat-dialog-close]="true">
        Aceptar
      </button>
    </mat-dialog-actions>
</ng-template> 